import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Table, TableLazyLoadEvent } from "primeng/table";
import { MedNotificationService } from "@mk/med-notification";
import { MedOptionType } from "@mk/med-ui";
import { PAGINATION_OPTIONS } from "@app/components/supplies/supplies.component";
import { DataService } from "@app/services/data.service";
import { OrganizationApiService } from "@app/services/organization-api.service";
import { OrganizationViewModel } from "@app/models/organization.model";
import { Router } from "@angular/router";

@Component({
  selector: "app-organizations",
  templateUrl: "./organizations.component.html",
  styleUrls: ["/organizations.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class OrganizationsComponent implements OnInit {

  constructor(
      private readonly notificationService: MedNotificationService,
      private readonly organizationApiService: OrganizationApiService,
      private readonly router: Router,
      public dataService: DataService,
  ) {
  }

  organizationList: OrganizationViewModel[] = [];

    @ViewChild("dt") dt: Table | undefined;
    tabHeader: {
        label: string;
        key: string;
    }[] = tabHeaderOrganizations;
    rows = 0;
    totalRows = 0;
    pageSize = 10;
    selectedPageNumber = 1;
    filterActive = true;
    filterField: string | string[] | null | undefined = "";
    tableState: TableLazyLoadEvent = {};
    sortOrder: number | undefined | null = null;

    readonly paginationOptions: MedOptionType<number>[] = PAGINATION_OPTIONS;

    loadData($event: TableLazyLoadEvent, resetState = false) {
      this.tableState = $event;
      this.filterField = $event.sortField;
      if (resetState) {
        if ($event.sortField) {
          this.filterActive = this.sortOrder !== -1;
        } else {
          this.filterActive = false;
        }
      }
      if (this.sortOrder === -1 && resetState) {
        this.sortOrder = null;
        this.dt?.reset();
      } else {
        this.getOrganizations(this.selectedPageNumber, $event.sortOrder === 1 ? "asc" : "desc", $event.sortField?.toString());
        this.sortOrder = $event.sortOrder;
      }
    }

    ngOnInit(): void {
      if ("DOZ" === this.dataService.userRoleValue.getValue() || "MOZ" === this.dataService.userRoleValue.getValue()) {
        this.router.navigate(["/"]);
      }
      this.loadColumnOrder();
    }

    saveColumnOrder() {
      localStorage.setItem("orgsColumnOrder", JSON.stringify(this.tabHeader));
    }

    loadColumnOrder() {
      const savedOrder = localStorage.getItem("orgsColumnOrder");
      if (savedOrder) {
        this.tabHeader = JSON.parse(savedOrder);
      }
    }

    getOrganizations(
      page = 0,
      order = "asc",
      field = "id",
    ): void {
      let params = new HttpParams();
      this.selectedPageNumber = page;
      const sortFieldAndOrder = `${field},${order}`;
      params = params.append("page", this.selectedPageNumber - 1);
      params = params.append("size", this.pageSize);
      params = params.append("sort", sortFieldAndOrder);

      const currentYear = new Date().getFullYear();
      this.organizationApiService.getOrganizationsMappedWithRecipients(currentYear, this.dataService.userRoleValue.getValue().toLowerCase(), params).subscribe(data => {
        this.totalRows = data.totalElements;
        this.organizationList = data.content;
      });
    }

    getFirstShowedRowIndex() {
      return this.selectedPageNumber === 1 ? 0 : (this.selectedPageNumber - 1) * this.pageSize;
    }

    copyToClipboard(productElement: string): void {
      const selBox = document.createElement("textarea");
      selBox.style.position = "fixed";
      selBox.style.left = "0";
      selBox.style.top = "0";
      selBox.style.opacity = "0";
      selBox.value = productElement;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand("copy");
      document.body.removeChild(selBox);
      this.notificationService.success(`${productElement} was copied to the clipboard`);
    }

    pageChange(pageNumber: number) {
      this.selectedPageNumber = pageNumber;
      this.loadData(this.tableState);
    }

    pageSizeChanged(pageSize: number) {
      this.pageSize = pageSize;
      this.selectedPageNumber = 1;
      this.loadData(this.tableState);
    }
}

export const tabHeaderOrganizations = [
  { key: "directionId", label: "Напрям" },
  { key: "regionName", label: "Область" },
  { key: "fullName", label: "Повна назва організації" },
  { key: "edrpou", label: "ЄДРПОУ" },
  { key: "shortName", label: "Коротка назва" },
  { key: "actualAddress", label: "Фактична адреса" },
  { key: "email", label: "Email закладу" },
  { key: "headName", label: "Керівник та контакти" },
  { key: "contactPerson", label: "Відповідальні особи та контакти" },
  { key: "subordinationId", label: "Рівень" },
  { key: "type", label: "Тип" },
  { key: "budgetYear", label: "Статус" },
];
